// Shared shape for the "شناسه" (colophon) metadata object — used by
// MetadataFieldsEditor.js (admin forms) and MetadataModal.js (public
// content pages) so both sides agree on field names without importing
// from each other.
export const EMPTY_METADATA = {
  english_author_name: "",
  text_id: "",
  translator_name: "",
  author_bio: "",
  extra_fields: [],
};

// The API always returns every field (see backend's domain.ContentMetadata),
// but this guards against a missing/malformed response (e.g. a draft
// loaded before the backend set a default) rather than crashing on
// metadata.extra_fields.map(...) over undefined.
export function normalizeMetadata(raw) {
  return {
    ...EMPTY_METADATA,
    ...raw,
    extra_fields: Array.isArray(raw?.extra_fields) ? raw.extra_fields : [],
  };
}

// Whether there's anything to actually show in the شناسه modal / worth
// sending back to the server as non-empty.
export function hasMetadataContent(metadata) {
  if (!metadata) return false;
  return Boolean(
    metadata.english_author_name ||
      metadata.text_id ||
      metadata.translator_name ||
      metadata.author_bio ||
      (metadata.extra_fields || []).some((field) => field.label || field.value)
  );
}
